import { startCase } from 'lodash';
import React from 'react';
import { H5 } from '../Type/Display.h';

const StateCityGuideLinks = ({ city, cityChildPageNodes, cityPagePath, state }) => {
  const nodes = [{
    path: cityPagePath,
    label: `How to File Chapter 7 in ${startCase(city)}, ${state}`,
  }];
  if (cityChildPageNodes.some(node => node.path.includes('/free-bankruptcy-lawyer/'))) {
    nodes.push({
      path: `${cityPagePath}/free-bankruptcy-lawyer/`,
      label: `Free Bankruptcy Lawyers for ${startCase(city)}, ${state}`,
    });
  }
  return (
    <section>
      <H5>Guides for {startCase(city)}</H5>
      <ul>
        {nodes.map(node => <li key={node.path}><a href={node.path}>{node.label}</a></li>)}
      </ul>
    </section>
  );
}

export default StateCityGuideLinks;
